export const FutureHomeExpensePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "home";
    item.icon = "house.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 2 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const FutureCarExpensePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "car";
    item.icon = "car.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 2 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const FutureChildrenExpensePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "children";
    item.icon = "baby.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const FutureTravelExpensePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "travel";
    item.icon = "travelCar.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const FutureCollectionExpensePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "collection";
    item.icon = "shoppingCart.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const FutureETCExpensePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "ETCExpense";
    item.icon = "smilingWithEyes.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const ChildrenEducationExpensePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};


export const LegacyIncomePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "legacy";
    item.icon = "twoHearts.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const SellBusinessIncomePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "SellBusiness";
    item.icon = "dollarBankNote.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const PropertyIncomePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.type = "Property";
    item.icon = "barChart.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};

export const OtherIncomePDF = (List) => {
  let sublist = [];
  let mainList = [];
  List?.map((item, index) => {
    item.is_rent = true;
    item.type = "OtherIncome";
    item.icon = "smilingWithBigEyes.svg";
    item.order = index + 1;
    sublist.push(item);
    if (sublist?.length === 3 || List?.length === item.order) {
      mainList.push(sublist);
      sublist = [];
      return;
    }
    return;
  });
  return mainList;
};